import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import get from "lodash/get"
import moment from "moment"
import { READ_NOTIFICATIONS } from "../actions/types"
import {
  readNotificationsSuccess,
  readNotificationsError,
} from "../actions/creators"

const { REACT_APP_NOTIFICATION_API_URL } = env

// read list saga
function* requestRead(action) {
  const lastWeek = moment()
    .subtract(1, `w`)
    .valueOf()

  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_NOTIFICATION_API_URL}/notification`,
      params: {
        limit: 40,
        orderBy: `createdDate desc`,
        query: `createdDate=gt=${lastWeek}`,
        force: true,
      },
    })
    const responseData = get(response, `data`)
    yield put(readNotificationsSuccess(action, responseData))
  } catch (error) {
    yield put(readNotificationsError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(READ_NOTIFICATIONS, requestRead)
}
